import { connect } from 'react-redux'

import { GroupOrdersMaster } from '@components/groupOrders'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state: any) => {
  const { groupOrderPage, headquarter: stateHeadquarter, user } = state
  const account = state.groupOrderPage && state.groupOrderPage.account
  const routedFromSearch = !!account
  const headquarter = user.lastLoggedInHq
  const { headquarters } = stateHeadquarter || {}
  const currentHq = headquarters.find((hq: any) => hq.id === headquarter)

  return {
    groupOrderPage,
    headquarter,
    currentHq,
    client: account,
    routedFromSearch,
    ...state.router,
  }
}

const mapDispatchToProps = () => {
  const { RestService, UIService, GroupOrdersService, HeadquarterService } =
    services
  const {
    AsyncLoadAccounts,
    LoadAccount,
    GetGroupOrderById,
    SearchClientSettings,
    SaveClientSettings,
    SaveClientGlobalSettings,
    GetClientGlobalSettings,
    SaveStaffingFeeSettings,
    SaveCustomServiceFeeSettings,
    LoadHeadquarters,
    SearchSlackAuthData,
    SearchPopUpCustomers,
    SaveUniversalMenuConfig,
  } = coordinators
  const {
    pResponseGeneric,
    pResponseAccount,
    pResponseGroupOrderClientSetting,
    pResponseGroupOrderClientSettings,
    pResponseClientGlobalSettings,
  } = presenters.Api

  const { displayFailureMessage } = UIService.FlashMessage
  const loadAccounts = AsyncLoadAccounts({ RestService, pResponseGeneric })
  const loadAccount = LoadAccount({ RestService, pResponseAccount })
  const getGroupOrderById = GetGroupOrderById({ RestService, HandleError })
  const getClientGlobalSettings = GetClientGlobalSettings({
    RestService,
    HandleError,
    pResponseClientGlobalSettings,
  })
  const searchClientSettings = SearchClientSettings({
    RestService,
    GroupOrdersService,
    HandleError,
    pResponseGroupOrderClientSettings,
  })
  const saveClientSettings = SaveClientSettings({
    RestService,
    UIService,
    HandleError,
    pResponseGroupOrderClientSetting,
  })
  const saveClientGlobalSettings = SaveClientGlobalSettings({
    RestService,
    UIService,
    HandleError,
    pResponseClientGlobalSettings,
  })
  const saveStaffingFeeSettings = SaveStaffingFeeSettings({
    RestService,
    UIService,
    HandleError,
    pResponseClientGlobalSettings,
  })

  const saveUniversalMenuConfig = SaveUniversalMenuConfig({
    RestService,
    UIService,
    HandleError,
  })

  const saveCustomServiceFeeSettings = SaveCustomServiceFeeSettings({
    RestService,
    UIService,
    HandleError,
    pResponseClientGlobalSettings,
  })

  const loadHeadquarters = LoadHeadquarters({
    HeadquarterService,
    RestService,
    pResponseHeadquarters: pResponseGeneric,
    HandleError,
  })

  const searchSlackAuthData = SearchSlackAuthData({
    RestService,
    HandleError,
  })

  const searchPopUpCustomers = SearchPopUpCustomers({
    RestService,
    HandleError,
  })

  const {
    newClientSettings,
    newClientGlobalSettings,
    newScheduleSettings,
    setGroupOrderPage,
  } = GroupOrdersService

  return {
    loadAccounts,
    loadAccount,
    getGroupOrderById,
    searchClientSettings,
    saveClientSettings,
    saveClientGlobalSettings,
    saveUniversalMenuConfig,
    getClientGlobalSettings,
    saveStaffingFeeSettings,
    saveCustomServiceFeeSettings,
    loadHeadquarters,
    searchSlackAuthData,
    searchPopUpCustomers,
    displayFailureMessage,
    newClientSettings,
    newClientGlobalSettings,
    newScheduleSettings,
    setGroupOrderPage,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupOrdersMaster)
